import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
const imagine = ['Imagine explaining building orientation using a complete structural cutaway.', 'Teaching search and rescue using detailed floor plans.', 'Showing equipment components with labeled illustrations.', 'Discussing fireground organization using operational maps.', 'Or presenting a realistic scenario with the main information already organized for your students.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-314" data-mp="3u2x6jmmcosd9">
      <div className="max-w-5xl mx-auto" data-id="element-315" data-mp="3gaqmhpg2u18j">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-316" data-mp="3g7l1alakjji3">
          <div data-id="element-317" data-mp="3bcfe7j5fjysf">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-neutral-900 uppercase" data-id="element-318" data-mp="erlpcf5ifn3o">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-neutral-900 mb-1" data-id="element-319" data-mp="9s8xth3p1rur">
              Firefighter education is visual.
            </p>
            <p className="text-xl font-semibold text-red-700 mb-5" data-id="element-320" data-mp="jqy9ut8wsi33">
              Your training material should be visual too.
            </p>
            <div className="space-y-3 text-neutral-800 leading-relaxed" data-id="element-321" data-mp="3s79rai0ukvye">
              <p data-id="element-322" data-mp="3n86o734fgzt2">{imagine.join(' ')}</p>
              <p className="font-semibold text-neutral-900" data-id="element-323" data-mp="3n98ak3qw98q3">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-324" data-mp="2fpqq2rfuv9">
                <span className="font-semibold text-neutral-900" data-id="element-325" data-mp="1w6n61dj0fn">Fire Service Instructor Atlas</span>{' '}
                is built around diagrams, equipment maps, building illustrations, scenario boards,
                comparison charts and quick-reference tools.
              </p>
            </div>
          </div>

          <div className="bg-neutral-100 border border-neutral-200 rounded-2xl p-6" data-id="element-326" data-mp="17fqev8u6uh57">
            <p className="text-sm font-bold text-neutral-900 uppercase tracking-wider mb-4" data-id="element-327" data-mp="1ce1p3koeatny">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-328" data-mp="1h8fgzd3uminv">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-neutral-800" data-id="element-329" data-mp="ohnksfms9u0j">
                  <CheckCircle2 size={16} className="text-red-700 shrink-0 mt-0.5" data-id="element-330" data-mp="tgiguj9rhf2l" />
                  <span data-id="element-331" data-mp="tibmbv8n1t90">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-neutral-900 mt-14" data-id="element-332" data-mp="13eekkq0dd7qo">
          <span className="text-red-700" data-id="element-333" data-mp="29vjnjmilb51r">100% VISUAL.</span> PRACTICAL. PROFESSIONAL. BUILT TO TEACH.
        </p>
      </div>
    </section>;
}